/* EYS TikTok videos: arrows for the row, and a pop-up that loads TikTok's player only when a video is tapped */
(function () {
  if (window.__eysTikTok) return;
  window.__eysTikTok = true;

  var PLAYER = 'https://www.tiktok.com/player/v1/';
  var PARAMS = '?autoplay=1&loop=1&rel=0&music_info=0&description=0&native_context_menu=0&closed_caption=1';

  function setupRow(root) {
    if (root.dataset.eysTtReady) return;
    root.dataset.eysTtReady = '1';
    var track = root.querySelector('[data-eys-tt-track]');
    var controls = root.querySelector('[data-eys-tt-controls]');
    var prev = root.querySelector('[data-eys-tt-prev]');
    var next = root.querySelector('[data-eys-tt-next]');
    if (!track) return;

    var ticking = false;
    function update() {
      ticking = false;
      var max = track.scrollWidth - track.clientWidth;
      if (controls) controls.classList.toggle('is-static', max <= 2);
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }
    function step(dir) {
      var item = track.querySelector('.eys-tt__item');
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      var width = item ? item.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      var per = Math.max(1, Math.floor((track.clientWidth + gap) / width) - 1);
      track.scrollBy({ left: dir * width * per, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function openVideo(card) {
    var root = card.closest('[data-eys-tt]');
    var id = card.getAttribute('data-eys-tt-play');
    var url = card.getAttribute('data-url') || (root && root.getAttribute('data-profile')) || 'https://www.tiktok.com';
    var dialog = root && root.querySelector('[data-eys-tt-dialog]');
    if (!id) return;
    if (!dialog || typeof dialog.showModal !== 'function') {
      window.open(url, '_blank', 'noopener');
      return;
    }
    var holder = dialog.querySelector('[data-eys-tt-player]');
    var link = dialog.querySelector('[data-eys-tt-open]');
    var frame = document.createElement('iframe');
    frame.src = PLAYER + encodeURIComponent(id) + PARAMS;
    frame.title = 'TikTok video';
    frame.setAttribute('allow', 'autoplay; fullscreen; encrypted-media; picture-in-picture');
    frame.setAttribute('allowfullscreen', '');
    holder.innerHTML = '';
    holder.appendChild(frame);
    if (link) link.href = url;
    dialog._eysTrigger = card;
    dialog.showModal();
    document.documentElement.classList.add('eys-tt-open');
  }

  /* Stops the video and tidies up. Safe to run twice: on our own close, and again on the dialog's close event (Esc key) */
  function cleanup(dialog) {
    var holder = dialog.querySelector('[data-eys-tt-player]');
    if (holder && holder.innerHTML) holder.innerHTML = '';
    document.documentElement.classList.remove('eys-tt-open');
    var trigger = dialog._eysTrigger;
    dialog._eysTrigger = null;
    if (trigger && document.contains(trigger)) trigger.focus();
  }

  function closeVideo(dialog) {
    if (dialog.open) dialog.close();
    cleanup(dialog);
  }

  function wireDialog(dialog) {
    if (dialog.dataset.eysTtWired) return;
    dialog.dataset.eysTtWired = '1';
    dialog.addEventListener('close', function () { cleanup(dialog); });
    /* A click on the dark backdrop (the dialog itself, outside the player) closes it */
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) closeVideo(dialog);
    });
  }

  document.addEventListener('click', function (e) {
    var card = e.target.closest && e.target.closest('[data-eys-tt-play]');
    if (card) {
      e.preventDefault();
      openVideo(card);
      return;
    }
    var close = e.target.closest && e.target.closest('[data-eys-tt-close]');
    if (close) {
      var dialog = close.closest('dialog');
      if (dialog) closeVideo(dialog);
    }
  });

  function start() {
    document.querySelectorAll('[data-eys-tt]').forEach(function (root) {
      setupRow(root);
      var dialog = root.querySelector('[data-eys-tt-dialog]');
      if (dialog) wireDialog(dialog);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();
